export default __webpack_public_path__ + "static/media/LLL Section 1.f58f9bd3.png";